import { styled } from 'styled-components';

import {
  searchJobHitOneWhenEarlyApplicantVisibleVar,
  searchJobHitTransparentWhenBorderHiddenVar,
  searchJobHitZeroWhenPostedDateHiddenVar,
} from 'modules/search/components/JobHit/searchJobHitCssVariables';
import { bodyMicroText, colors, cssBreakpoints, transition } from 'theme/theme';

export const SearchJobHitFooterHolder = styled.div`
  padding-top: 10px;
  border-top: 1px solid
    var(${searchJobHitTransparentWhenBorderHiddenVar}, ${colors.calloutGrey});
  font-size: 12px;
  position: relative;
  transition: ${transition};
  transition-property: border-top-color;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    font-size: 14px;
  }
`;

export const SearchJobHitFooterContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SearchJobHitFooterPublishedTimeago = styled.span`
  color: ${colors.lightContentGrey};
  ${bodyMicroText};
  line-height: 1;
  transition: ${transition};
  transition-property: opacity;
  opacity: var(${searchJobHitZeroWhenPostedDateHiddenVar}, 1);
`;

export const SearchJobHitFooterEarlyApplicant = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.natureGreen};

  transition: ${transition};
  transition-property: opacity;
  opacity: var(${searchJobHitOneWhenEarlyApplicantVisibleVar}, 0);

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    position: absolute;
    top: 0;
    left: 0;

    background: #f4fff1;
    background: linear-gradient(
      90deg,
      rgb(244 255 241 / 0%) 0%,
      rgb(244 255 241 / 100%) 20%,
      rgb(244 255 241 / 100%) 80%,
      rgb(244 255 241 / 0%) 100%
    );
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding: 8px 50px 12px;
    margin-left: -50px; /* Offset padding left */
    margin-top: -10px; /* Offset padding top */
  }
`;
